export default __webpack_public_path__ + "static/media/RDNT.0cef70b9.svg";